import { render } from "./addPost.vue?vue&type=template&id=64d1d070&scoped=true"
import script from "./addPost.vue?vue&type=script&lang=js"
export * from "./addPost.vue?vue&type=script&lang=js"

import "./addPost.vue?vue&type=style&index=0&id=64d1d070&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d1d070"]])

export default __exports__